export const loadWebcams = (payload) => {
    return {
        type: "LOAD_WEBCAMS",
        payload
    }
};
export const setActiveCamera = (payload) => {
    return {
        type: "SET_ACTIVE_CAMERA",
        payload
    }
};
export const setImages = (imgs, camid) => {
    return {
        type: "SET_IMAGES",
        imgs: imgs, 
        camid: camid
    }
};
export const setRangeValues = (values, camid) => {
    return {
        type: "SET_RANGE_VALUES",
        values: values, 
        camid: camid
    }
};
export const setRangeSettings = (setting, camid) => {
    return {
        type: "SET_RANGE_SETTINGS",
        setting: setting, 
        camid: camid
    }
};
export const setCameraInterval = (dispatch, values, camid) => {
    return {
        type: "SET_CAMERA_INTERVAL",
        dispatch: dispatch,
        values: values, 
        camid: camid
    }
};
export const setDateSelected = (dispatch, selected_date, camid) => {
    return {
        type: "SET_DATE_SELECTED",
        dispatch: dispatch,
        selected_date: selected_date, 
        camid: camid
    }
};
export const setWeatherData = (data, camid) => {
    return {
        type: "SET_WEATHER_DATA",
        data: data, 
        camid: camid
    }
};
export const setAddressData = (data, camid) => {
    return {
        type: "SET_ADDRESS_DATA",
        data: data, 
        camid: camid
    }
};
export const setIsSliderPlayings = (isPlaying, camid, galleryRef) => {
    return {
        type: "SET_IS_SLIDER_PLAYINGS",
        isPlaying: isPlaying, 
        camid: camid,
        galleryRef: galleryRef
    }
};
export const setIsFade = (payload) => {
    return {
        type: "SET_IS_FADE",
        payload
    }
}
export const setIsSidebar = (payload) => {
    return {
        type: "SET_IS_SIDEBAR",
        payload
    }
}

